import React from 'react';
import { MicroCTA } from './shared/MicroCTA';
export function Chapter3() {
  return <section className="py-8 border-t border-gray-200" id="journey" data-id="element-66">
      <h2 className="text-2xl font-bold mb-6" data-id="element-67">Försöken som ledde ingenstans</h2>
      <p className="mb-4 text-lg" data-id="element-68">
        Med forskningsinformationen i bagaget började jag experimentera. Jag
        gjorde det många gör: ökade kaffet. Skärpa i 40 minuter, sedan ett fall.
        Huvudvärk på eftermiddagen. Sömnproblem på natten. Ännu mer kaffe dagen
        efter. En cykel som kändes ohållbar.
      </p>
      <p className="mb-4 text-lg" data-id="element-69">
        Jag laddade ner hjärnträningsappar. Färgglada spel som lovade att "träna
        min hjärna" och "bygga kognitiv reserv". Jag spelade troget varje dag i
        tre veckor. Mitt poäng förbättrades. Jag blev bättre på just spelet,
        inte på verkligheten. När jag fortfarande stod i mataffären och inte
        kunde minnas vad jag skulle köpa, kändes de där tio minuterna med
        matchande färger plötsligt meningslösa.
      </p>
      <div className="mb-6" data-id="element-70">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9sipDvijZVC6R5c8TQfzJD/2a9d6a21-d261-4d2f-8124-65072154a1d6_min.webp" alt="Äldre kvinna med silvervitt hår och vit kofta som ser frustrerad ut med post-it lappar på väggen bakom henne" className="w-full h-auto rounded-lg shadow-md object-cover" style={{
        height: '400px'
      }} width="1200" height="400" data-id="element-71" />
      </div>
      <p className="mb-4 text-lg" data-id="element-72">
        Jag satte upp gula lappar överallt. På spegeln: "Ta vitaminer". På
        ytterdörren: "Kom ihåg plånboken". På datorn: "Ring mamma". Och blev
        plötsligt en person som levde i ett akvarium av påminnelser. Min dotter
        kom på besök och tittade runt i lägenheten. "Det ser ut som en detektivs
        anslagstavla här, mamma," sa hon. Vi skrattade, men jag kände mig
        blottad.{' '}
        <span className="text-gray-700 font-semibold" data-id="element-73">
          Var detta min nya identitet? Den glömska kvinnan som behöver lappar
          för att fungera?
        </span>
      </p>
      <p className="mb-4 text-lg" data-id="element-74">
        Jag prövade meditation. Satt på en kudde på golvet varje morgon och
        försökte fokusera på andningen. "Det handlar om att träna
        uppmärksamheten," hade en vän sagt. Ibland hjälpte det – jag kände mig
        lugnare, mindre splittrad. Men det löste inte problemet med att minnas
        namn eller att hålla tråden i ett samtal.
      </p>
      <p className="mb-4 text-lg" data-id="element-75">
        Jag förändrade min kost. Mer grönsaker, mer fisk, mindre socker. Jag sov
        bättre, hade mer energi. Men fortfarande – orden som försvann mitt i en
        mening, nycklarna som jag letade efter medan de låg i min hand. Det var
        som att försöka laga ett läckande tak med bara en hammare – rätt
        verktyg, men inte tillräckligt.
      </p>
      <p className="mb-4 text-lg" data-id="element-76">
        En kväll ringde jag min vän Karin, som är läkare. "Jag känner mig dum,"
        sa jag. "Som om jag borde kunna lösa det här själv." Hon var tyst en
        stund. "Anna," sa hon sedan, "om du hade problem med synen, skulle du
        skämmas för att skaffa glasögon? Det här är inte annorlunda. Ibland
        behöver kroppen stöd."
      </p>
      <blockquote className="border-l-4 border-[#2e7d32] pl-4 italic my-6 text-lg" data-id="element-77">
        "Det är inte svaghet att söka stöd. Det är intelligens att inse vad
        kroppen behöver{' '}
        <span className="not-italic font-semibold" data-id="element-78">
          innan det går för långt
        </span>
        ."
      </blockquote>
      <p className="mb-4 text-lg" data-id="element-79">
        Det var Margareta, pensionerad apotekare och min granne, som öppnade en
        ny dörr. Vi satt på hennes balkong en eftermiddag i juni. Jag berättade
        om mina frustrationer, om känslan av att kämpa mot en osynlig
        motståndare.
      </p>
      <p className="mb-4 text-lg" data-id="element-80">
        "Vill du läsa på om en kombination som många pratar om?" frågade hon.
        "Bacopa, B-vitaminer, C-vitamin, zink. Stimulantia-fritt. Jag gillar det
        för att det bygger på sådant som kroppen redan använder."
      </p>
      <p className="mb-4 text-lg" data-id="element-81">
        Jag var skeptisk. Marknaden är full av löften. Men det fanns något med
        idén om stöd snarare än snabbverkande fix. Något som resonerade med vad
        forskarna hade sagt. Jag gick hem och började läsa, artikel efter
        artikel, studie efter studie.
      </p>
      <div className="mt-6" data-id="element-82">
        <MicroCTA text="Vad jag upptäckte" href="#discovery" className="text-right" data-id="element-83" />
      </div>
    </section>;
}